// import React, { useRef, useEffect } from 'react';
// import ReactDOM from 'react-dom/client';
// import App from './App';
// import shadowStyles from './shadow-styles.css';
//
// const ShadowDomComponent = () => {
//     const shadowHostRef = useRef(null);
//
//     useEffect(() => {
//         // Создаем Shadow DOM
//         const shadowRoot = shadowHostRef.current.attachShadow({ mode: 'open' });
//         console.log(shadowStyles)
//         const styleElement = document.createElement("style");
//         styleElement.textContent = `
//       body {
//     margin: 0;
//     font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
//     'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
//     sans-serif;
//     -webkit-font-smoothing: antialiased;
//     -moz-osx-font-smoothing: grayscale;
//
// }
//
// code {
//     font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
//     monospace;
// }
// .App {
//     text-align: center;
//     margin: auto;
//     height: 100vh; /* Обеспечиваем, что приложение будет занимать всю высоту экрана */
//     display: flex;
//     justify-content: center;
//     align-items: center;
// }
//
// .App-logo {
//     height: 20vmin; /* Логотип будет занимать 20% от ширины экрана */
//     pointer-events: none;
// }
//
// .App-header {
//     background-color: #282c34;
//     min-height: 100vh;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: center;
//     font-size: calc(10px + 2vmin); /* Размер шрифта зависит от ширины экрана */
//     color: white;
//     width: 100%; /* Заголовок занимает всю ширину экрана */
// }
//
// .App-link {
//     color: #61dafb;
// }
//
// @keyframes App-logo-spin {
//     from {
//         transform: rotate(0deg);
//     }
//     to {
//         transform: rotate(360deg);
//     }
// }
//
// @media (max-width: 768px) {
//     .App-header {
//         font-size: calc(8px + 4vmin); /* Уменьшаем размер шрифта для меньших экранов */
//     }
//
//     .App-logo {
//         height: 15vmin; /* Логотип будет меньше на мобильных устройствах */
//     }
// }
//
// .slider {
//
//     overflow: hidden; /* Prevent overflow if content is larger */
// }
//
// .slider__controls {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     width: 100%;
//     padding-top: 10px;
//
// }
//
//
// @media (max-width: 768px) {
//     .slider {
//         max-width: 100%;
//         height: 60vh;  /* Smaller height on mobile */
//     }
// }
//
// @media (max-width: 480px) {
//     .slider {
//         max-width: 100%;
//         height: 50vh;  /* Further decrease height on very small screens */
//     }
// }
//
// .selectable-block {
//     margin: 10px;
//     border: 2px solid #ccc;
//     border-radius: 8px;
//     cursor: pointer;
//     transition: background 0.3s, border-color 0.3s;
//     text-align: center;
//     background-color: #37518e;
//     color: #ffffff;
//     font-family: "Pacifico", cursive;
//     font-weight: 400;
//     font-style: normal;
// }
// .selectable-block h2 {
//     font-size: 33px;
//     margin-bottom: 5px;
// }
// .selectable-block h3 {
//     font-size: 25px;
//     margin-top: 2px;
//     margin-bottom:  2px;
// }
// .selectable-block p {
//     margin-top: 2px;
// }
//
// .selectable-block:hover {
//     background: #4867b1;
// }
//
// .selected {
//     border-color: #dfeaff;
//     background: #4767ba;
// }
//
// .blocks-container {
//     display: flex;
//     justify-content: center;
//     flex-direction: column;
//     gap: 15px;
//     margin-top: 20px;
//     width: 100%; /* Блоки будут адаптироваться по ширине экрана */
//     height: 50%; /* Устанавливаем высоту для контейнера блоков */
// }
//
// .selected-info {
//     margin-top: 20px;
// }
//
// @media (max-width: 768px) {
//     .home-container {
//         gap: 30px; /* Уменьшаем расстояние между элементами для маленьких экранов */
//     }
// }
//
// .header {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     color: #4876e8;
//
// }
// .header__close-btn {
//     background: none;
//     border: none;
//     color: #000000;
//     font-size: 24px;
//     cursor: pointer;
// }
//
// .header__title {
//     display: flex;
//     flex-direction: column;   /* Align text vertically */
//     justify-content: center;  /* Center the text vertically */
//     align-items: center;      /* Center the text horizontally */
//     text-align: center;       /* Ensure the text is centered */
//     flex-grow: 1;
//     padding-left: 80px/* Allow the title to take available space */
// }
// .header__language-selector {
//     position: relative;
//     display: inline-block;
//     margin-right: 3%;
//
// }
//
// .header__language-btn {
//     background: none;
//     border: none;
//     cursor: pointer;
//     display: flex;
//     align-items: center;
// }
//
// .header__flag {
//     width: 35px;
//     height: 35px;
//     border-radius: 50px;
// }
//
// .header__dropdown {
//     position: absolute;
//     top: 40px;
//     right: 0;
//     background: white;
//     border: 1px solid #ccc;
//     border-radius: 5px;
//     box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
//     display: flex;
//     flex-direction: column;
// }
//
// .header__dropdown-item {
//     display: flex;
//     align-items: center;
//     gap: 8px;
//     padding: 10px;
//     border: none;
//     background: none;
//     cursor: pointer;
//     font-size: 16px;
// }
//
// .header__dropdown-item:hover {
//     background: #f0f0f0;
// }
//
// @media (max-width: 768px) {
//     .header__title {
//         font-size: 20px; /* Уменьшаем размер заголовка на маленьких экранах */
//     }
//
//     .header__flag {
//         width: 30px; /* Меньше размер флага на мобильных устройствах */
//         height: 30px;
//     }
// }
//       `;
//         shadowRoot.appendChild(styleElement);
//
//         // Создаем контейнер для React-приложения
//         const appContainer = document.createElement('div');
//         shadowRoot.appendChild(appContainer);
//
//         // Рендерим React-приложение внутрь Shadow DOM
//         const root = ReactDOM.createRoot(appContainer);
//         root.render(<App />);
//
//         // Очистка при размонтировании компонента
//         return () => {
//             root.unmount();
//         };
//     }, []); // Пустой массив зависимостей, чтобы выполнить только один раз
//
//     return <div ref={shadowHostRef}></div>;
// };
//
// export default ShadowDomComponent;
//

import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
/* eslint-disable import/no-webpack-loader-syntax */
import shadowStyles from '!!raw-loader!./shadow-styles.css';
/* eslint-enable import/no-webpack-loader-syntax */
const ShadowDomComponent = () => {
    const shadowHostRef = useRef(null);

    useEffect(() => {
        const hostElement = shadowHostRef.current;

        if (hostElement.shadowRoot) {
            console.warn("ShadowRoot already created, pass attachShadow.");
            return;
        }


        const shadowRoot = hostElement.attachShadow({ mode: 'open' });


        const styleElement = document.createElement("style");
        styleElement.textContent = shadowStyles;  // Используем CSS как строку
        shadowRoot.appendChild(styleElement);


        const appContainer = document.createElement('div');
        shadowRoot.appendChild(appContainer);


        const root = ReactDOM.createRoot(appContainer);
        root.render(<App />);

        return () => {
            root.unmount();
        };
    }, []);

    return <div ref={shadowHostRef}></div>;
};

export default ShadowDomComponent;